import { Box, Card, CardContent, Divider, FormControlLabel, FormGroup, Grid, List, ListItem, Switch, Typography } from '@mui/material';
import CommonLayout from 'layouts/DashboardLayout';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { fetchPaymentPlatformStatus, fetchSignupStatus, getBlazeStatus, getBlockReason, openSnackbar, updateBlazeStatus, updateBlockReason, updatePaymentPlatformStatus, updateSignupStatus } from '../../redux/slices/common';
import icon1 from '../../assets/images/persona.png';
import icon2 from '../../assets/images/age-checker.png';
import icon3 from '../../assets/images/registration.png';
import icon4 from '../../assets/images/didit.png';

import leisurepay_logo from '../../assets/images/leisurepay-logo.jpg';
import maverick_logo from '../../assets/images/maverick_logo.jpeg';
import blaze_logo from '../../assets/images/blaze.png';

import CommonQuillEditor from 'common/editor';
import MDButton from 'components/MDButton';
import { getData } from 'utilities/common';
import { STILO } from 'utilities/constants';
import { HYPERWOLF } from 'utilities/constants';
import { getPermissionsByMode } from 'utilities/common';
import { hasSectionPermission } from 'utilities/common';

export default function ManageSignupType() {
  const dispatch = useDispatch();
  const { signupStatus = {}, isLoading = false, paymentPlatformStatus = {}, blockReason = {} ,blazeAPIEnabled} = useSelector(state => state.common);
  const { data } = blockReason
  const [messageData, setMessageData] = useState('')
  const adminsMode = getData('adminsMode')
  const isStilo = JSON.parse(adminsMode) === STILO
  const isHyperwolf = JSON.parse(adminsMode) === HYPERWOLF

  let localUser = getData('login-user-info')
  if (localUser) {
    localUser = JSON.parse(localUser)
  }

  const adminMode = localStorage.getItem("adminsMode") ? JSON.parse(localStorage.getItem("adminsMode")) : null;
  const permissionsForMode = getPermissionsByMode(localUser?.permissions, adminMode);

  const canCreate = hasSectionPermission(permissionsForMode, "Settings", "Create");
  const canEdit = hasSectionPermission(permissionsForMode, "Settings", "Edit/Update");
  const canView = hasSectionPermission(permissionsForMode, "Settings", "View Only");
  const canDelete = hasSectionPermission(permissionsForMode, "Settings", "Delete");

  useEffect(() => {
    setMessageData(data?.blockReason)
  }, [data])

  const onStatusChangeHandler = (e) => {
    let payload = {
      'personaStatus': 'inactive',
      'registerStatus': 'inactive',
      'agecheckerStatus': 'inactive',
      'diditStatus': 'inactive'

    };
    payload = {
      ...payload,
      [e.target.name]: e.target.checked ? 'active' : 'inactive'
    };
    if (Object.values(payload).every(status => status === 'inactive')) {
      showResponseMessage('Atleast one registration should be active', 'error');
      return;
    }
    dispatch(updateSignupStatus(payload)).unwrap().then((res) => {
      showResponseMessage(res?.message, 'success');
      dispatch(fetchSignupStatus());
    });
  };

  const onPaymentStatusChangeHandler = (e) => {
    let payload = {
      'maverickStatus': 'inactive',
      'leisurepayStatus': 'inactive'
    };
    payload = {
      ...payload,
      [e.target.name]: e.target.checked ? 'active' : 'inactive'
    };
    if (Object.values(payload).every(status => status === 'inactive')) {
      showResponseMessage('Atleast one platform should be active', 'error');
      return;
    }
    dispatch(updatePaymentPlatformStatus(payload)).unwrap().then((res) => {
      showResponseMessage(res?.message, 'success');
      dispatch(fetchPaymentPlatformStatus());
    });
  };

  const showResponseMessage = (message, errortype) => {
    if (errortype === 'success') {
      dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
    }
    if (errortype === 'error') {
      dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
    }
  };

  useEffect(() => {
    if(isHyperwolf){
      dispatch(getBlazeStatus());
    }
    dispatch(fetchSignupStatus());
    dispatch(fetchPaymentPlatformStatus());
    dispatch(getBlockReason());
  }, []);

  const handleSubmit = () => {
    dispatch(updateBlockReason({ blockReason: messageData })).unwrap()
      .then(res => {
        showResponseMessage(res?.message, 'success')
      })
  }

  const onBlazeStatusChangeHandler = (e) => {
    let payload = {
      'blazeAPIEnabled': false,
    };
    payload = {
      ...payload,
      [e.target.name]: e.target.checked ? true : false
    };
   
    dispatch(updateBlazeStatus(payload)).unwrap().then((res) => {
      showResponseMessage(res?.message, 'success');
      dispatch(getBlazeStatus());
    });
  };

  return (
    <CommonLayout>
      {
        canView && 
        <>
          <Box p={{ xs: 2, sm: 3, lg: 4 }}>
            <Grid container justifyContent="center">
              <Grid item xs={12} lg={6}>
                <Typography variant='h4' mb={3}>Members Registration</Typography>
                <Card>
                  <CardContent sx={{ px: 4, py: 3 }}>
                    <FormGroup onChange={canEdit ? onStatusChangeHandler : ""}>
                      <List>
                        <ListItem alignItems="center" sx={{ justifyContent: 'space-between' }}>
                          <Typography variant="h5" fontWeight="medium" display="inline-flex" alignItems="center" gap={1}>
                            <img src={icon1} height="28px" />
                            Persona:
                          </Typography>
                          <FormControlLabel
                            disabled={!canEdit || isLoading}
                            name='personaStatus'
                            control={<Switch checked={signupStatus?.personaStatus === 'active'} />}
                            sx={{ m: 0 }}
                          />
                        </ListItem>
                        <Divider />
                        <ListItem alignItems="center" sx={{ justifyContent: 'space-between' }}>
                          <Typography variant="h5" fontWeight="medium" display="inline-flex" alignItems="center" gap={1}>
                            <img src={icon4} height="28px" />
                            Didit:
                          </Typography>
                          <FormControlLabel
                            disabled={!canEdit || isLoading}
                            name='diditStatus'
                            control={<Switch checked={signupStatus?.diditStatus === 'active'} />}
                            sx={{ m: 0 }}
                          />
                        </ListItem>
                        <Divider />

                        {
                          !(isStilo || isHyperwolf) && <>
                            <ListItem alignItems="center" sx={{ justifyContent: 'space-between' }}>
                              <Typography variant="h5" fontWeight="medium" display="inline-flex" alignItems="center" gap={1}>
                                <img src={icon2} height="28px" />
                                AgeChecker:
                              </Typography>
                              <FormControlLabel disabled={!canEdit || isLoading} name='agecheckerStatus' control={<Switch checked={signupStatus?.agecheckerStatus === 'active'} />} sx={{ m: 0 }} />
                            </ListItem>
                            <Divider />
                            <ListItem alignItems="center" sx={{ justifyContent: 'space-between' }}>
                              <Typography variant="h5" fontWeight="medium" display="inline-flex" alignItems="center" gap={1}>
                                <img src={icon3} height="28px" />
                                Register:
                              </Typography>
                              <FormControlLabel disabled={!canEdit || isLoading} name='registerStatus' control={<Switch checked={signupStatus?.registerStatus === 'active'} />} sx={{ m: 0 }} />
                            </ListItem>
                          </>
                        }
                      </List>
                    </FormGroup>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Box>
          {
            !isHyperwolf &&
            <Box p={{ xs: 2, sm: 3, lg: 4 }}>
              <Grid container justifyContent="center">
                <Grid item xs={12} lg={6}>
                  <Typography variant='h4' mb={3}>Payment Platform</Typography>
                  <Card>
                    <CardContent sx={{ px: 4, py: 3 }}>
                      <FormGroup onChange={canEdit ? onPaymentStatusChangeHandler : ""}>
                        <List>
                          <ListItem alignItems="center" sx={{ justifyContent: 'space-between' }}>
                            <Typography variant="h5" fontWeight="medium" display="inline-flex" alignItems="center" gap={1}>
                              <img src={maverick_logo} height="28px" />
                              Mevrick:
                            </Typography>
                            <FormControlLabel disabled={!canEdit || isLoading} name='maverickStatus' control={<Switch checked={paymentPlatformStatus?.maverickStatus === 'active'} />} sx={{ m: 0 }} />
                          </ListItem>
                          <Divider />
                          <ListItem alignItems="center" sx={{ justifyContent: 'space-between' }}>
                            <Typography variant="h5" fontWeight="medium" display="inline-flex" alignItems="center" gap={1}>
                              <img src={leisurepay_logo} height="28px" />
                              Leisurepay:
                            </Typography>
                            <FormControlLabel disabled={!canEdit || isLoading} name='leisurepayStatus' control={<Switch checked={paymentPlatformStatus?.leisurepayStatus === 'active'} />} sx={{ m: 0 }} />
                          </ListItem>
                          <Divider />
                        </List>
                      </FormGroup>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Box>
          }
          {/* <Box p={{ xs: 2, sm: 3, lg: 4 }}>
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={6}>
            <Typography variant='h4' mb={3}>Reason for Online Payment Block (Message that the customer sees)</Typography>
            <Card>
              <CardContent sx={{ p: 4 }}>
                <FormGroup onChange={onPaymentStatusChangeHandler}>
                  <CommonQuillEditor 
                    value={messageData || ''}
                    onChange={(value)=>setMessageData(value)}
                  />
                </FormGroup>
                <MDButton
                  sx={{ minWidth: '140px', marginTop: '20px', marginBottom: '10px' }}
                  type='button'
                  variant='contained'
                  color='primary'
                  onClick={handleSubmit}
                  // disabled={isUploading || loading}
                  // loading={loading}

                >
                  Save
                </MDButton>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box> */}
        </>
      }


    </CommonLayout>
  );
}